import { FormHandle } from '@/hooks/use-form-handle.hook';
import { getMetadataControlActionOptions } from '@/lib/models/policy-model/metadata-controls';
import { PolicyModel } from '@/lib/models/policy-model/policy.model';
import { FC } from 'react';
import ServiceControlItem from './item';

interface Props {
  formHandle: FormHandle<PolicyModel>;
  readonly: boolean;
  withNotSet?: boolean;
}

const DataPrivacyItem: FC<Props> = ({ formHandle, readonly, withNotSet = true }) => {
  const DescriptionEl = (
    <>
      For supported services, attempt to enforce settings which will prevent data from being added
      to training dataset. When enabled, this setting will be reflected in user event metadata.
    </>
  );

  return (
    <ServiceControlItem
      formHandle={formHandle}
      readonly={readonly}
      label="Attempt to enforce training data protection"
      description={DescriptionEl}
      controlType="enforce-data-privacy"
      options={getMetadataControlActionOptions('enforce-data-privacy')}
      withNotSet={withNotSet}
    />
  );
};

export default DataPrivacyItem;
